import React, { useContext, useState } from 'react';
import styles from './chevy.module.css';
import { CommonButton } from '~/common/components/CommonButton';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';
import { Trial } from '~/common/pages/Trial/Trial';
import { CONTENT_IDS, MODAL_TYPES, TRIAL_TYPES } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { ModalContentContext } from '~/common/context/ContentContext';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';

const Chevy = () => {
  const { modifier, setContentId, trialType, setTrialType } = useAppStore(
    useShallow((state) => ({
      modifier: state.modifier,
      setContentId: state.setContentId,
      trialType: state.trialType,
      setTrialType: state.setTrialType,
    }))
  );
  const [currentStep, setCurrentStep] = useState<number>(0);
  const data = useContext(ModalContentContext);

  const handleCallback = (step: number) => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Step change',
      cta_position: `Chevy Trial Modal - Business - Step ${step}`,
    });
    setCurrentStep(step);
  };

  const handlePersonalClick = () => {
    if (
      modifier === MODAL_TYPES.CHEVYPREMIUM ||
      modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL ||
      modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL1
    ) {
      gtagEnvelope('event', 'cta_click', {
        cta_name: 'Next',
        cta_position: 'Chevy Trial Modal - Premium',
      });
      setContentId(CONTENT_IDS.PREMIUM);
      setTrialType(TRIAL_TYPES.PREMIUM);
      setCurrentStep(1);
    } else {
      gtagEnvelope('event', 'cta_click', {
        cta_name: 'Try Personal free',
        cta_position: 'Chevy Trial Modal',
      });
      setTimeout(() => {
        window.location.href = data?.successUrl;
      }, 100);
    }
  };

  const handleBusinessClick = () => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Next',
      cta_position: 'Chevy Trial Modal - Business',
    });
    setContentId(CONTENT_IDS.BUSINESS);
    setTrialType(TRIAL_TYPES.BUSINESS);
    setCurrentStep(1);
  };

  if (!data) {
    return (
      <div className={styles['modal-cards']}>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
      </div>
    );
  }

  return currentStep === 0 ? (
    <div className={styles['modal-cards']}>
      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img src={data.card1?.image} alt="Business illustration" />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>{data.card1?.title}</h4>
          <p>{data.card1?.text}</p>
          <a className={`${styles['lp-button']} ${styles['primary']} ${styles['positive']} ${styles['jumbo']}`}></a>
          <CommonButton stylesModifier="black" onClick={handleBusinessClick}>
            {data.card1?.button}
          </CommonButton>
        </div>
      </div>

      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img src={data.card2?.image} alt="Personal illustration" />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>{data.card2?.title}</h4>
          <p>{data.card2?.text}</p>
          <CommonButton onClick={handlePersonalClick}>{data.card2?.button}</CommonButton>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles['modal-cols']}>
      <div className={styles['modal-col1']}>
        {trialType === TRIAL_TYPES.BUSINESS && (
          <div className={styles['step-indicators']}>
            <button className={styles.active}>1</button>
            <div className={`${styles['step-indicators-line']} ${currentStep === 2 ? styles.active : ''}`}></div>
            <button className={currentStep === 2 ? styles.active : ''}>2</button>
          </div>
        )}
        <TrialContentProvider>
          <Trial handleCallback={handleCallback} modalContent={data} />
        </TrialContentProvider>
      </div>
      <div
        className={styles['modal-col2']}
        style={
          trialType === TRIAL_TYPES.BUSINESS
            ? { backgroundColor: '#a5c1dc' }
            : { backgroundColor: '#DEECDB', display: 'flex', justifyContent: 'end' }
        }
      >
        <img src={trialType === TRIAL_TYPES.BUSINESS ? data.secondStep?.image : data.secondStep?.image2} alt="Trial" />
      </div>
    </div>
  );
};

export default Chevy;
